import {
  ReactNode,
  createContext,
  useEffect,
  useState,
  useContext,
  useRef,
} from "react";
import { SignalContext } from "./SignalContext";
import { AuthContext } from "./AuthContext";
import DataControllerManager from "lib/dataControler";

type DataContolerContextType = {
  dataControllerManager: DataControllerManager;
  getControllerManagerWithWaiter: () => Promise<DataControllerManager>;
};

const initialValue = {
  dataControllerManager: null,
  getControllerManagerWithWaiter: () => Promise.resolve(null),
};

export const DataControlerContext =
  createContext<DataContolerContextType>(initialValue);

let controllerMamagerWaiter = [];
export default function DataContolerProvider({
  children,
}: {
  children?: ReactNode;
}) {
  const { signal, sessionId, wsIsOpen, getDb } = useContext(SignalContext);
  const { user } = useContext(AuthContext);
  const dataManagerRef = useRef(null);
  const [dataControllerManager, setDataControllerManager] = useState(
    initialValue.dataControllerManager,
  );
  useEffect(() => {
    if (dataControllerManager && controllerMamagerWaiter?.length) {
      controllerMamagerWaiter.forEach((item) => item(dataControllerManager));
      controllerMamagerWaiter = [];
    }
  }, [dataControllerManager]);
  useEffect(() => {
    // stop second controller manager creation
    if (!sessionId || !signal || !wsIsOpen || dataControllerManager) {
      return;
    }
    const _dataControllerManager = new DataControllerManager();
    DataControllerManager.sessionId = sessionId;
    DataControllerManager.signal = signal;
    DataControllerManager.orgId = user?.orgId;
    DataControllerManager.getDb = getDb;
    dataManagerRef.current = _dataControllerManager;
    setDataControllerManager(_dataControllerManager);
  }, [sessionId, signal, wsIsOpen]);
  const getControllerManagerWithWaiter = (): Promise<DataControllerManager> => {
    return new Promise((resolve) => {
      if (dataManagerRef.current) {
        resolve(dataManagerRef.current);
        controllerMamagerWaiter = [];
      } else {
        console.log("push into waiter");
        controllerMamagerWaiter?.push(resolve);
      }
    });
  };
  return (
    <DataControlerContext.Provider
      value={{
        dataControllerManager,
        getControllerManagerWithWaiter,
      }}
    >
      {children}
    </DataControlerContext.Provider>
  );
}
